import { Box, Typography } from '@mui/material'
import Header from '../components/Header'
import BatchUploadInstructions from './BatchUploadInstructions'
import ImportTrackingNumbers from './ImportTrackingNumbers'
import PhysicalOrdersList from './PhysicalOrdersList'
import BatchSnapshotModal from './BatchSnapshotModal'
import OrdersMetrics from './OrdersMetrics'

const PhysicalOrders = () => {
  return (
    <Box>
      <Header title="Physical Orders" />
      <OrdersMetrics />
      <BatchUploadInstructions />
      <ImportTrackingNumbers />
      <Typography variant="h5">Order Batches</Typography>
      <PhysicalOrdersList />
      <BatchSnapshotModal />
    </Box>
  )
}

export default PhysicalOrders
